import { render, staticRenderFns } from "./TreatmentAreas.vue?vue&type=template&id=b876308e&"
import script from "./TreatmentAreas.vue?vue&type=script&lang=js&"
export * from "./TreatmentAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports